import { CssType, ThemeType } from 'src/theme/jss-types';

export const AssignVehicleStyles = (theme: ThemeType) : CssType => ({
  modal: {
    maxWidth: '408px',
  },
  label: {
    fontSize: '12px',
    color: '#333333',
    fontWeight: 600,
    marginTop: '8px',
  },
  button: {
    borderRadius: '4px !important',
    padding: '0px 16px !important',
    marginLeft: '16px !important',
    fontSize: '14px',
  },
});
